import type { RestRecord } from '@libs/data-access/entities'
import moment from 'moment'
import { Rest } from 'snap-redux/modules/rests/index'

type Params = {
  userContractId: number
  date: Date | string
}

export const getDefaultRestModel = ({
  userContractId,
  date = new Date()
}: Params) => {
  return new Rest({
    user_contract_id: userContractId,
    starts_at: moment(date).format(),
    // Here we add 5 hours to make that the fieldDatePicker in some of the "form" to be from AM to PM. (8h - 13h)
    ends_at: moment(date).add(5, 'hours').format()
  }) as unknown as RestRecord
}
